let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5AHuk")).then(() => parcelRequire('fPVZ9'));